export enum SaleStatementTypeEnum {
  Intermediation = 'intermediation',
  Klok = 'klok',
}

export enum SaleStatementTypeIdEnum {
  Klok = 1,
  Intermediation = 2,
}

export const SaleStatementTypeEnumLabel: Record<SaleStatementTypeEnum, string> = {
  [SaleStatementTypeEnum.Intermediation]: 'Intermediação',
  [SaleStatementTypeEnum.Klok]: 'Klok',
};
